import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getProviders = ({ currencyId, pageNumber }) => {
  return axios.get(`/paymentMethod/manualBank/${currencyId}/${pageNumber}`);
};

export const useBankProviders = ({ currencyId, pageNumber, config }) => {
  return useQuery({
    ...config,
    queryKey: ['currency__manual_bank_providers', currencyId, pageNumber],
    queryFn: () => getProviders({ currencyId, pageNumber }),
  });
};
